import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Row, Label, Input, FormGroup, FormFeedback } from 'reactstrap';
import ModalUI from '../../../shared/components/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ShowRetentionToInvoice from './ShowRetentionToInvoice';
import { formatNumber } from '../../Utils/Money';
import moment from 'moment';

const no_op = () => { }
const FormAddRetention = ({ selectedInvoice, retentionsTypeList = [], refresh = no_op, retentionToAction = null, onEdit = false, setOnEdit = no_op, isDelete = false, setIsdeleted = no_op }) => {
    const [errors, setErrors] = useState({});
    const [retentionsByInvoice, setRetentionsByInvoice] = useState(null);
    const [incomeValueRetention, setIncomeValueRetention] = useState('');
    const [retentionType, setRetentionType] = useState('');
    const [percentageOnTheIncome, setPercentageOnTheIncome] = useState('');
    const [noteRetention, setNoteRetention] = useState('');
    const [totalInvoice, setTotalInvoice] = useState(0);

    const [openAlert, setOpenAlert] = useState(false);
    const [modalAlert, setModalAlert] = useState({ message: '', color: '', title: '' });

    useEffect(() => {
        getRetentionsByInvoice();
        calculateTotal(selectedInvoice);
    }, [selectedInvoice])

    useEffect(() => {
        if (onEdit) {
            let searchRetentionType = retentionsTypeList.find((ret) => ret.id_tipo_retencion === retentionToAction.tipo_retencion.toString());
            setIncomeValueRetention(retentionToAction.importe);
            setRetentionType(searchRetentionType);
            setPercentageOnTheIncome(retentionToAction.porcentaje_info);
            setNoteRetention(retentionToAction.nota);
        }
        if (isDelete) {
            setOpenAlert(true);
            setModalAlert({ title: 'Advertencia', color: 'warning', message: '¿Deseas eliminar esta Retención?' });
        }
    }, [retentionToAction, onEdit, isDelete])

    const calculateTotal = (invoice) => {
        let total_tercero = 0;
        let total_abonos = 0;
        if (invoice.hasOwnProperty('servicios')) { //Factura en salud
            if (invoice.servicios !== null && invoice.servicios !== undefined) {
                if (invoice.tipo !== null) {
                    if (invoice.tipo === 1) { // cuando es particular el total de la factura es el total del copago
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.total)
                                total_abonos = 0;
                            })
                        }
                    } else { // cuando es otro regimen 
                        if (invoice.servicios.recibos_caja.length > 0) {
                            invoice.servicios.recibos_caja.forEach((recibo) => {
                                total_tercero += parseInt(recibo.valor_tercero)
                                total_abonos += parseInt(recibo.total);
                            })
                        }
                    }
                }
            } else if (invoice.hasOwnProperty('detalles_comerciales')) { //Factura Comercial
                total_tercero = parseInt(invoice.detalles_comerciales?.total);
                total_abonos = parseInt(invoice.detalles_comerciales?.copago);
            } else {
                total_tercero = 0;
                total_abonos = 0;
            }
        }
        setTotalInvoice(total_tercero);
        return { ["total_tercero"]: total_tercero, ["total_abonos"]: total_abonos }
    }

    const validateForm = () => {
        const errors = {};
        var error = false;
        if (incomeValueRetention == "") {
            errors.valor_ingresado = "Ingrese el importe de la Retención";
            error = true;
        }

        if (retentionType == "") {
            errors.tipo_retencion = "Seleccione un tipo de Retención";
            error = true;
        }

        /*  if(errors.hasOwnProperty('importe')){
             setModalAlert({
                 message: errors.importe,
                 color: 'danger',
                 title: "Error!"
             });
         } */
        console.log("ERRORSFORM", errors);
        setErrors(errors);
        return error;
    }

    //Lista todas las retenciones por factura
    const getRetentionsByInvoice = async () => {
        //setLoad(true);
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/listar-retenciones-factura?id_factura_t=' + selectedInvoice.id_factura_t, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
        })
            .then((response) => {
                if (response.status != 500 && response.status != 403) {
                    return response.json();
                }
                else {
                    throw new Error(response.json());
                }
            })
            .then((data) => {
                //setLoad(false);
                console.log("DATOSGET", data);
                setRetentionsByInvoice(data);
                /* if (selectedInvoice !== null && selectedInvoice !== undefined) {
                    goToInvoice(selectedInvoice.num_fac_ter);
                } */
            })
            .catch((error) => {
                console.log(error)
            })
    };


    const saveRetention = async () => {
        if (!validateForm()) {
            let dataSend = {
                importe: parseInt(incomeValueRetention),
                transaccion: null,
                fecha_pago: null,
                forma_pago: null,
                nota: noteRetention,
                id_factura_t: selectedInvoice.id_factura_t,
                portentaje_info: percentageOnTheIncome,
                tipo_retencion: parseInt(retentionType.id_tipo_retencion),
                retencion: true
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    console.log("PaymentSaved", data);
                    setIncomeValueRetention('');
                    setRetentionType('');
                    setNoteRetention('');
                    setPercentageOnTheIncome('');
                    if (refresh !== undefined && refresh !== null) {
                        refresh();
                    }
                    getRetentionsByInvoice();
                    setOpenAlert(true);
                    setModalAlert({
                        message: "Guardado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.log(error)
                    setModalAlert({
                        message: "No se pudo guardar la retención",
                        color: 'danger',
                        title: "Error!"
                    });
                })
        }
    }

    const updateRetention = async () => {
        if (!validateForm()) {
            let dataSend = {
                importe: parseInt(incomeValueRetention),
                transaccion: null,
                fecha_pago: null,
                forma_pago: null,
                nota: noteRetention,
                id_factura_t: selectedInvoice.id_factura_t,
                portentaje_info: percentageOnTheIncome,
                tipo_retencion: parseInt(retentionType.id_tipo_retencion),
                retencion: true,
                id_pago: parseInt(retentionToAction.id_pago)
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/update', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then((response) => {
                    if (response.status != 500 && response.status != 403) {
                        return response.text();
                    }
                    else {
                        throw new Error(response.text());
                    }
                })
                .then((data) => {
                    console.log("PaymentUpdated", data);
                    setIncomeValueRetention('');
                    setRetentionType('');
                    setNoteRetention('');
                    setPercentageOnTheIncome('');
                    if (refresh !== undefined && refresh !== null) {
                        refresh();
                    }
                    getRetentionsByInvoice();
                    setOpenAlert(true);
                    if (setOnEdit !== undefined && setOnEdit !== null) {
                        setOnEdit(false);
                    }
                    setModalAlert({
                        message: "Actualizado con exito",
                        color: 'success',
                        title: "Exitoso!"
                    });
                })
                .catch((error) => {
                    console.log(error)
                    setModalAlert({
                        message: "No se pudo actualizar la retención",
                        color: 'danger',
                        title: "Error!"
                    });
                })
        }
    }

    const onDelet = () => {
        if (setIsdeleted !== undefined && setIsdeleted !== null) {
            setIsdeleted(false);
        }
        let dataSend = { id_pago: parseInt(retentionToAction?.id_pago) };
        console.log(dataSend);
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'pagos/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    console.log(response);
                    if (refresh !== undefined && refresh !== null) {
                        refresh();
                    }
                    getRetentionsByInvoice();
                    setModalAlert({ title: 'Acción completada', color: 'success', message: 'El pago fue eliminado' });
                    return response.json();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    const onOkModal = () => {
        switch (modalAlert.color) {
            case "success":
                if (setIsdeleted !== undefined && setIsdeleted !== null) {
                    setIsdeleted(false);
                }
                setOpenAlert(!openAlert)
                break;
            case "warning":
                onDelet();
                break;
        }
    }


    return (
        <Fragment>
            {
                retentionsByInvoice !== null ?
                    retentionsByInvoice.length > 0 ?
                        <Row style={{ margin: '0.5em 0em' }}>
                            <h5><b>RETENCIONES A LA FACTURA. {selectedInvoice.num_fac_ter} :</b></h5>
                        </Row>
                        : null
                    : null
            }
            <Row>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {
                        retentionsByInvoice &&
                        retentionsByInvoice.map((retencion) => (
                            <div style={{ margin: '0.25em 0.5em', maxWidth: '30%' }}>
                                <ShowRetentionToInvoice key={retencion.id_pago} retention={retencion} />
                            </div>
                        ))
                    }
                </div>
            </Row>

            <Row>
                <h4 style={{ margin: '1em 0em', padding: '0em 0.5em' }}><b>{onEdit ? 'ACTUALIZAR' : 'REGISTRAR'}  RETENCIÓN A LA FACTURA No. {selectedInvoice.num_fac_ter}</b></h4>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '1em 0em' }}>
                    <div><p><b>Cliente: </b>{selectedInvoice.nombre_facturado}</p></div>
                    <div><p><b>Total de la Factura: $</b>{formatNumber(totalInvoice)}</p></div>
                    <div><p><b>Fecha de Emisión: </b>{moment(selectedInvoice.fecha_emision_format).format('DD-MM-YYYY')}</p></div>
                    {/* <div><p><b>Importe a Pagar: $ {formatNumber(incomeToPay)}</b></p></div> */}
                </div>
                <hr style={{ color: '#55e5bb' }}></hr>
                <Col md={6}>
                    <TextField
                        label="Importe de la Retención"
                        required
                        value={incomeValueRetention}
                        onChange={(event) => {
                            setIncomeValueRetention(event.target.value)
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("valor_ingresado") ? errors.valor_ingresado !== "" : false}
                        helperText={errors.valor_ingresado}
                    />
                </Col>
                <Col md={6}>
                    <TextField
                        required
                        select
                        id="type_retention_select"
                        label="Seleccione un tipo de Retención"
                        type="text"
                        className="medical-material-form__field"
                        value={retentionType}
                        InputLabelProps={{
                            shrink: true
                        }}
                        onChange={(e) => {
                            //onSelectedInvoice(e);
                            setRetentionType(e.target.value);
                            console.log('EVENTO', e)
                        }}
                        error={errors.hasOwnProperty("tipo_retencion") ? errors.tipo_retencion !== "" : false}
                        helperText={errors.tipo_retencion}
                    >
                        {retentionsTypeList?.map((retention) => (
                            <MenuItem key={retention.id_tipo_retencion} value={retention}>
                                {retention.tipo_retencion}
                            </MenuItem>
                        ))}
                    </TextField>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <TextField
                        label="Porcentaje"
                        value={percentageOnTheIncome}
                        onChange={(event) => {
                            setPercentageOnTheIncome(event.target.value);
                        }}
                        type="number"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("porcentaje") ? errors.porcentaje !== "" : false}
                        helperText={errors.porcentaje}
                    />
                </Col>
                <Col md={6}>
                    <TextField
                        label="Nota"
                        multiline
                        maxRows={4}
                        value={noteRetention}
                        onChange={(event) => {
                            setNoteRetention(event.target.value)
                        }}
                        type="text"
                        className="medical-material-form__field"
                        error={errors.hasOwnProperty("nota") ? errors.nota !== "" : false}
                        helperText={errors.nota}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                </Col>
                <Col md={6}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ marginRight: 10, marginTop: 10 }}
                            color="primary"
                            size="sm"
                            id="searchBtn"
                            onClick={() => {
                                if (onEdit) {
                                    updateRetention();
                                } else {
                                    saveRetention();
                                }
                            }}
                        >
                            {onEdit ? 'Actualizar' : 'Guardar'}
                        </Button>
                    </div>
                </Col>
            </Row>
            {openAlert ?
                <ModalUI
                    color={modalAlert.color}
                    title={modalAlert.title}
                    message={modalAlert.message}
                    modal={openAlert}
                    toggle={() => { setOpenAlert(!openAlert) }}
                    onOk={() => { onOkModal() }}
                /> : null}
        </Fragment>
    )
}

export default FormAddRetention